import React from 'react'
import { graphql, Link } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { INLINES, BLOCKS } from '@contentful/rich-text-types'
import { Helmet } from 'react-helmet'

import Layout from '../components/Layout/Layout'
import backIcon from '../resources/images/big-arrow-right.svg'

import {
	StyledBackButton,
	StyledBackImage,
	StyledBlogContainerHeaderTitle,
	StyledBlogInnerContainer,
	StyledDetailInnerData
} from '../styles/style'

import '../index.css'
import '../fonts.css'

export const query = graphql`
	query($slug: String!) {
		contentfulBlogPost(slug: { eq: $slug }) {
			title
			publishedDate(formatString: "MMMM Do, YYYY")
			picture {
				title
				file {
					url
				}
			}
			body {
				json
			}
		}
	}
`

const Blog = props => {
	const { body, picture, title } = props.data.contentfulBlogPost

	return (
		<Layout darkColor>
			<Helmet>
				<title>{title}</title>
				<meta name='description' content={body?.json.content[0].content[0].value} />
				<meta name='image' content={picture?.file?.url} />
				<meta name='twitter:card' content='summary_large_image' />
				<meta name='twitter:site' content='@publisher_handle' />
				<meta name='twitter:title' content={title} />
				<meta name='twitter:description' content={body?.json.content[0].content[0].value} />
				<meta name='twitter:image:src' content={picture?.file?.url} />
				<meta property='og:title' content={title} />
				<meta property='og:type' content='website' />
				<meta property='og:image' content={picture?.file?.url} />
				<meta property='og:image:secure_url' content={picture?.file?.url} />
				<meta property='og:image:type' content='image/jpeg' />
				<meta property='og:image:width' content='400' />
				<meta property='og:image:height' content='300' />
				<meta property='og:image:alt' content='kyc' />
				<meta property='og:description' content={body?.json.content[0].content[0].value} />
			</Helmet>
			<StyledBlogInnerContainer>
				<Link to='/blog' style={{ textDecoration: 'none' }}>
					<StyledBackButton>
						<StyledBackImage src={backIcon} alt='' />
						<span>Back to blog</span>
					</StyledBackButton>
				</Link>
				<StyledBlogContainerHeaderTitle mrgbottom={'32px'}>{title}</StyledBlogContainerHeaderTitle>

				<StyledDetailInnerData>
					<img
						src={picture?.file?.url}
						alt={`${picture?.title}`}
						style={{ maxWidth: '100%', width: '100%', height: 'auto' }}
					/>
					{documentToReactComponents(body.json, {
						renderNode: {
							[BLOCKS.EMBEDDED_ASSET]: ({
								data: {
									target: { fields }
								}
							}) => (
								<img
									src={fields.file['en-US'].url}
									alt={fields.description['en-US']}
									style={{ maxWidth: '100%' }}
								/>
							),
							[INLINES.HYPERLINK]: ({ data: { uri }, content }) => {
								return uri && uri.includes('youtube.com/embed') ? (
									<div className='iframe-container'>
										<iframe src={uri} title='Kvalifika-video' frameborder='0' allowfullscreen />
									</div>
								) : (
									<Link style={{ color: '#000' }} to={uri}>
										{content[0].value}
									</Link>
								)
							},
							[INLINES.ENTRY_HYPERLINK]: ({
								data: {
									target: { slug, title }
								}
							}) => (
								<Link style={{ color: '#000' }} to={slug}>
									{title}
								</Link>
							)
						}
					})}
				</StyledDetailInnerData>
			</StyledBlogInnerContainer>
		</Layout>
	)
}

export default Blog
